import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { createDateFormatters, type DateFormatters } from '../utils/dateFormats';

/**
 * Datumopmaak in de taal die de gebruiker nu ziet.
 *
 * `useTranslation()` zorgt voor een re-render bij een taalwissel, dus de formatters
 * worden vanzelf opnieuw opgebouwd en elke datum op het scherm volgt mee.
 */
export const useDateFormat = (): DateFormatters => {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage ?? i18n.language;

  return useMemo(() => createDateFormatters(language), [language]);
};
